export default __webpack_public_path__ + "static/media/404-Graphic.ea209c6a.svg";